export let SuggestTitleEvents = /*#__PURE__*/function (SuggestTitleEvents) {
  SuggestTitleEvents["GenerateSuggestedTitle"] = "editor_ai:start_suggest_a_title";
  SuggestTitleEvents["ReplaceConfluenceTitle"] = "editor_ai:replace_confluence_title";
  return SuggestTitleEvents;
}({});